module.exports = __webpack_public_path__ + "media/images/siq-blank-c63f864315e13e26d9884bb73145ed9b.svg";